import { Link } from 'react-router-dom';
import { Logo } from "@/components/ui/Logo";

export default function Footer() {
  return (
    <footer className="dark bg-background border-t border-border py-12 text-foreground">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-6">
              <Logo variant="light" className="h-12 w-auto" />
            </div>
            <p className="text-muted-foreground max-w-sm">
              Delivering Experiences. Revolutionizing employee transport with safety, technology, and sustainability at the core.
            </p>
          </div>
          
          <div>
            <h4 className="font-bold text-foreground mb-6">Company</h4>
            <ul className="space-y-4 text-sm text-muted-foreground">
              <li><a href="#" className="hover:text-primary">About Us</a></li>
              <li><a href="#" className="hover:text-primary">Careers</a></li>
              <li><a href="#" className="hover:text-primary">Press</a></li>
              <li><a href="/#contact" className="hover:text-primary">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-foreground mb-6">Legal</h4>
            <ul className="space-y-4 text-sm text-muted-foreground">
              <li><Link to="/privacy-policy" className="hover:text-primary">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="hover:text-primary">Terms of Service</Link></li>
              <li><Link to="/cookie-policy" className="hover:text-primary">Cookie Policy</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-border pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © 2024 WorkRidePro. All rights reserved.
          </p>
          <div className="flex gap-6">
            {/* Social icons would go here */}
          </div>
        </div>
      </div>
    </footer>
  );
}
